// extracted by mini-css-extract-plugin
export default {"form":"register_form__W4Aqs","link":"register_link__TyBDl"};